import Swal from "sweetalert2";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../../components/Navbar';

const AddFormExpense = () => {
    const [formData, setFormData] = useState({
        FinancialFollowUpV: '',
        AddictFormExpense: '',
    });

    const [financialFollowUps, setFinancialFollowUps] = useState([]);
    const [selectedFollowUp, setSelectedFollowUp] = useState(null);
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalCollected, setTotalCollected] = useState(0);

    const showSuccessAlert = (text) => {
        Swal.fire({
            title: "نجاح!",
            text: text,
            icon: "success",
            confirmButtonText: "حسناً",
        });
    };

    const showErrorAlert = (text) => {
        Swal.fire({
            title: "خطأ!",
            text: text,
            icon: "error",
            confirmButtonText: "حاول مرة أخرى",
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => {
            const updatedFormData = { ...prevFormData, [name]: value };
            if (name === 'FinancialFollowUpV') {
                const selected = financialFollowUps.find(f => f._id === value);
                setSelectedFollowUp(selected);
                setTotalAmount(selected?.totalAmount || 0);
                setTotalCollected(selected?.totalAmountCollected || 0);
                updatedFormData.AddictFormExpense = selected?.totalAmountCollected || 0;
            }
            return updatedFormData;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (totalCollected < totalAmount) {
            showErrorAlert('المبلغ المدفوع أقل من المبلغ المطلوب');
            return;
        }
        try {
            const res = await axios.post(`${process.env.REACT_APP_HOST_SERVER}form-expense`, formData);
            const expenseId = res.data._id;
            await axios.post(`${process.env.REACT_APP_HOST_SERVER}family-box`, {
                formExpenseAmount: expenseId,
                amountType: 'حالة',
                details: (selectedFollowUp && selectedFollowUp.AddictForm && selectedFollowUp.AddictForm.addict ? selectedFollowUp.AddictForm.addict.addictName : '') + " " + "مصاريف شهرية"
            });
            await axios.post(`${process.env.REACT_APP_HOST_SERVER}notification`, {
                Notifaction: `تم اضافة مصروف للاستمارة بنجاح`,
            });
            showSuccessAlert('تمت الاضافة بنجاح');
            setFormData({ FinancialFollowUpV: '', AddictFormExpense: '' });
        } catch (error) {
            console.error(error);
            showErrorAlert('حدث خطأ اثناء الاضافة');
        }
    };

    useEffect(() => {
        const fetchFinancialFollowUps = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOST_SERVER}follow-up`);
                setFinancialFollowUps(response.data);
            } catch (error) {
                console.error('Error fetching financial follow-ups', error);
            }
        };

        fetchFinancialFollowUps();
    }, []);

    return (
        <div className="px-8 py-5 bg-gray-100 min-h-screen">
            <Navbar />
            <h1 className="text-4xl text-center font-extrabold my-10 text-blue-600">اضف مصروف جديد</h1>
            <div className="max-w-4xl mx-auto p-8 bg-white rounded-xl shadow-lg">
                <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-8">
                    <div>
                        <label htmlFor="FinancialFollowUpV" className="block text-lg font-medium mb-2">اسم الحالة</label>
                        <select
                            id="FinancialFollowUpV"
                            name="FinancialFollowUpV"
                            value={formData.FinancialFollowUpV}
                            onChange={handleChange}
                            className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            <option value="">اختر اسم الحالة</option>
                            {financialFollowUps.map((followUp) => (
                                <option key={followUp._id} value={followUp._id}>
                                    {followUp.AddictForm && followUp.AddictForm.addict ? followUp.AddictForm.addict.addictName : "لا يوجد"}
                                </option>
                            ))}
                        </select>
                    </div>
                    {selectedFollowUp && (
                        <>
                            <div className="text-lg font-medium mb-2">المبلغ المطلوب: {totalAmount}</div>
                            <div className="text-lg font-medium mb-2">المبلغ المدفوع: {totalCollected}</div>
                        </>
                    )}
                    <div>
                        <label htmlFor="AddictFormExpense" className="block text-lg font-medium mb-2">المصروف</label>
                        <input
                            type="number"
                            id="AddictFormExpense"
                            name="AddictFormExpense"
                            readOnly
                            value={formData.AddictFormExpense}
                            onChange={handleChange}
                            className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div className="col-span-1">
                        <button
                            type="submit"
                            className="w-full bg-blue-600 text-white text-lg font-semibold py-3 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                        >
                            أضافة مصروف
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddFormExpense;